<!--eslint-disable vue/no-v-text-v-html-on-component-->
<template>
  <iButton
    v-if="shouldRenderButton"
    :key="defaultTemplateName"
    :size="myButtonSize"
    :variant="getOptionValue(ButtonType)"
    :disabled="getOptionValue(ButtonDisabled)"
    :width="getOptionValue(LayoutWidth)"
    :height="getOptionValue(LayoutHeight)"
    :style-overrides="buttonStyleOverrides"
    :text-alignment="getOptionValue(TextAlignment)"
    :content-width="myContentWidth"
    :icon-left="displayLeftIcon ? getOptionValue(Icon) : ''"
    :icon-right="displayRightIcon ? getOptionValue(Icon) : ''"
    :icon-top="displayTopIcon ? getOptionValue(Icon) : ''"
    :icon-bottom="displayBottomIcon ? getOptionValue(Icon) : ''"
    :icon-left-size="displayLeftIcon ? myIconSize : 'standard'"
    :icon-right-size="displayRightIcon ? myIconSize : 'standard'"
    :icon-top-size="displayTopIcon ? myIconSize : 'standard'"
    :icon-bottom-size="displayBottomIcon ? myIconSize : 'standard'"
    :icon-color="fontColor"
    @click="handleButtonClick"
  >
    <template #[defaultTemplateName]>
      <iRichText
        v-if="hasStartedEditing"
        ref="richTextElement"
        :model-value="initialValue"
        prevent-new-line
        :preview="previewMode"
        :show-toolbar="false"
        :show-bubble-menu="true"
        :tools-to-disable="['text-align', 'link', 'bullet-list']"
        :style-overrides="{
          borderWidth: 'none',
          borderRadius: 'none',
          paddingLeft: 'none',
          paddingRight: 'none',
          paddingTop: 'none',
          paddingBottom: 'none',
        }"
        v-bind="textOnlyAttributes"
        @click="editMode && handleClick($event)"
        @blur="handleBlur"
        @keydown.enter="handleBlur"
        @update:model-value="handleTextOptionUpdate($event)"
      />
      <iText
        v-else
        v-bind="textOnlyAttributes"
        :style-overrides="textOnlyAttributes.textStyleOverrides"
        @click="editMode && handleClick($event)"
      >
        {{ initialValueText }}
      </iText>
    </template>
  </iButton>
</template>

<script>
import {
  ButtonElementMixin,
} from "%/dynamic-component-editor/standard-elements/button-element/button-element-mixin";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import TextOptions from "%/dynamic-component-editor/bundles/text-options";

export default {
  name: "StaticButtonElement",
  elementPanelSettings: {
    displayName: "Button",
    displayIcon: "button",
    elementType: "element",
    elementGroup: "general",
  },
  mixins: [ButtonElementMixin],
  optionBundles: [
    PositioningOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "hug",
      "default.layout-height": "hug",
    }),
    new AppearanceOptions({
      "default.border-radius": "large",
    }, {
      "border-radius": false,
    }),
    ButtonOptions,
    SpacingOptions,
    new BasicTextOptions({
      "default.font-color": {
        value: "light",
        source: "theme.font",
      },
    }),
    new TextOptions({
      "default.text-wrap": "nowrap",
    }),
  ],
};
</script>

<style lang="scss" scoped>
</style>
